/* Opens policy accordions when customers follow a direct policy link. */
(function () {
  function revealHash() {
    var id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { return; }
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    var disclosure = target.matches('details') ? target : target.closest('details');
    if (disclosure) {
      disclosure.open = true;
      requestAnimationFrame(function () { target.scrollIntoView({block:'start'}); });
    }
  }
  document.addEventListener('DOMContentLoaded', revealHash);
  window.addEventListener('hashchange', revealHash);
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var url = new URL(link.href, window.location.href);
    var menu = link.closest('.cv-mobile-nav') && link.closest('.cv-menu');
    if (menu && url.origin === location.origin && url.pathname === location.pathname && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      menu.open = false;
      if (url.hash) {
        var destination;
        try { destination = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (_) { destination = null; }
        if (destination) {
          // Keep keyboard focus on the section reached, not inside the closed menu.
          var temporaryTabindex = !destination.hasAttribute('tabindex');
          if (temporaryTabindex) destination.setAttribute('tabindex', '-1');
          destination.focus({ preventScroll: true });
          if (temporaryTabindex) destination.addEventListener('blur', function () { destination.removeAttribute('tabindex'); }, { once: true });
        }
      }
    }
    if (url.origin === location.origin && url.pathname === location.pathname && url.hash === location.hash) revealHash();
  });
})();
